import { useQuery } from '@tanstack/react-query';

import { IPartnerHierarchyResponse } from '../types/hierarchy';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const getPartnerHierarchy = async ({
  partnerId,
  makeRequest,
}: {
  partnerId: string;
  makeRequest: ImperativeRequestFn;
}): Promise<IPartnerHierarchyResponse> => {
  const { data, error } = await makeRequest({
    path: `/admin/partners/${partnerId}/hierarchy`,
  });
  if (error) throw new Error(error?.message ?? String(error));

  return data;
};

type QueryFnType = typeof getPartnerHierarchy;

export const useGetPartnerHierarchy = (
  partnerId: string,
  config?: QueryConfig<QueryFnType>
) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillage');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    enabled: !!partnerId,
    ...config,
    queryKey: ['partner-hierarchy', partnerId],
    queryFn: () => getPartnerHierarchy({ partnerId, makeRequest }),
  });
};
